
<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.Task">
    <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
        <div appDialogDragArea cdkDragHandle></div>
        <app-task-consent-modal [taskViewModel]="data.taskViewModel" [invokedFromTheCase]="data.invokedFromTheCase" (taskUpdatedEvent)="taskUpdated()" (closed)="close()"></app-task-consent-modal>
    </mat-dialog-content>
</div>
